import { ServiceListItem } from '@repo/common/interfaces';
import { createStore } from 'zustand/vanilla';
import { persist } from 'zustand/middleware';

export type OnboardingState = {
  storeId?: string;
  serviceListItems: ServiceListItem[];
  formIsLoading: boolean;
};

export type OnboardingActions = {
  setStoreId: (storeId?: string) => void;
  setServiceListItems: (serviceListItem?: ServiceListItem[]) => void;
  setFormIsLoading: (value: boolean) => void;
  reset: () => void;
};

export type OnboardingStore = OnboardingState & OnboardingActions;

export const defaultInitState: OnboardingState = {
  storeId: undefined,
  serviceListItems: [],
  formIsLoading: false,
};

export const createOnboardingStore = (
  initState: OnboardingState = defaultInitState,
) => {
  return createStore<OnboardingStore>()(
    persist(
      (set) => ({
        ...initState,
        setStoreId: (storeId?: string) =>
          set((state) => ({
            ...state,
            storeId,
          })),
        setServiceListItems: (serviceListItems?: ServiceListItem[]) =>
          set((state) => ({
            ...state,
            serviceListItems,
          })),
        setFormIsLoading: (newValue: boolean) =>
          set((state) => ({
            ...state,
            formIsLoading: newValue,
          })),
        reset: () => {
          return set((state) => ({
            ...state,
            storeId: undefined,
            serviceListItems: [],
            formIsLoading: false,
          }));
        },
      }),
      {
        name: 'onboarding-store',
      },
    ),
  );
};
